import type { TokenErrorReason } from './tokenErrorReason';

/** An access token and when it expires (ms). */
export interface TokenPayload {
  token: string;
  tokenExpiration: number;
}

/** The page's answer to the worker's token request: a refusal is an answer, not a failure. */
export type TokenAnswer =
  | ({ status: 'granted' } & TokenPayload)
  | { status: 'refused'; reason: TokenErrorReason };

/** A token closer to its expiry than this is treated as stale. */
export const TOKEN_FRESHNESS_THRESHOLD_MS = 60_000;

/** Whether the token can be used for a while yet (more than the freshness threshold left). */
export function isFreshToken(payload: Partial<TokenPayload> | undefined, now = Date.now()): payload is TokenPayload {
  return (
    typeof payload?.token === 'string' &&
    payload.token.length > 0 &&
    typeof payload.tokenExpiration === 'number' &&
    payload.tokenExpiration > now + TOKEN_FRESHNESS_THRESHOLD_MS
  );
}
